import { IOption } from '@/types/selectOption.interface'
import { IUploaderForm } from '@/types/uploadForm.interface'

/**
 * Converts tags from IOption[] format to {name, id}[] format for backend
 */
export const convertTagsToBackendFormat = (
	tags: IUploaderForm['tags']
): Array<{ name: string; id: string }> => {
	if (!Array.isArray(tags)) return []
	return tags.map(tag => ({
		name: tag.label,
		id: tag.value
	}))
}

/**
 * Converts tags from {name, id}[] format to IOption[] format for form
 */
export const convertTagsToFormFormat = (
	tags: Array<{ name?: string; id?: string | number }> | undefined
): IOption[] => {
	if (!tags || !Array.isArray(tags)) return []
	return tags.map(tag => ({
		label: tag.name || '',
		value: String(tag.id || '')
	}))
}
